import { AloUserIdentity, getDefaultAloUserIdentity } from './AloUserIdentity'


//Représente des informations d'indentification d'un utilisateur
export interface AloForgottenPass extends AloUserIdentity {
    userEmail:string
    userNewPass:string
    userEncryptedToken:string
}

export const getDefaultAloForgottenPass = ():AloForgottenPass => {
    return {   
        ...getDefaultAloUserIdentity(),
        userEmail:"",
        userNewPass:"",
        userEncryptedToken:""
    }
}